import { render, staticRenderFns } from "./RouterLink.vue?vue&type=template&id=b7483e5c&scoped=true"
import script from "./RouterLink.vue?vue&type=script&lang=ts"
export * from "./RouterLink.vue?vue&type=script&lang=ts"
import style0 from "./RouterLink.vue?vue&type=style&index=0&id=b7483e5c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7483e5c",
  null
  
)

export default component.exports